import React from "react";
import HeroSection from "./component/Hero";
import GrowthSection from "./component/Growth";
import StableCurrenciesSection from "./component/StableCurrency";
import SavingsGoalsSection from "./component/SavingGoal";
import Carousel from "../homepage/component/carousel";
import FeatureSection from "./component/Feature";
import InvestmentSection from "./component/Investment";
import Navbar from "../../components/navbar";
import Footer from "../homepage/component/footer";

const Personal = () => {
  return (
    <div>
      <Navbar />

      <HeroSection />
      <FeatureSection />
      <GrowthSection />
      <StableCurrenciesSection />
      <SavingsGoalsSection />
      <InvestmentSection />
      <div className="px-4 md:px-16">

           <Carousel />
      </div>
   
      <Footer />

    </div>
  );
};

export default Personal;
